export class MinLengthValidationRule {
    // #region Vars
    name = 'minlen';
    // #endregion
    // #region Validate
    validate(validation, rule, value, object) {
        //Message
        let tMin = rule.props?.minlen ?? rule.props;
        let tMessage = host.localizer?.tc('system.Validation.StringLengthMin', [validation.displayName, '', rule.props]);
        //Data
        if (value === undefined || value === null) {
            return {
                isValid: true
            };
        }
        if (/(string|array)/.test(typeof value) === false) {
            return {
                isValid: false,
                message: tMessage
            };
        }
        if (value.length > 0 && value.length < tMin) {
            return {
                isValid: false,
                message: tMessage
            };
        }
        return {
            isValid: true
        };
    }
}
